import React, { useEffect, useState } from "react"
import { toast } from "react-toastify"
import Input from "./../Input"

import { apiCall, getOfflineToken } from './../../../Helper'

export default ({ show, toggleShow, setIsLoading, name, family, setNameFamily }) => {
  const [newName, setNewName] = useState(name)
  const [newFamily, setNewFamily] = useState(family)

  return (
    show ? <div className={`modal flexed fl-c full`}>
      <div className={`p-45 bg-top-nav w-40 shadow-mild radius-8 popIn`}>
        <h3 className="m-0 text-shadow font-16 px-8">
          افزودن نام</h3>
        <hr className="mb-0" />
        <form action="" onSubmit={(e) => {
          e.preventDefault();
          setNameFamily({ name: newName, family: newFamily })
          toggleShow(false)
        }}>
          <div className="px-32 pt-24 pb-16 modal-content">
            <div className="grid" style={{ gridTemplateColumns: '2fr', gap: 16 }}>
              <Input className="bg-light blocked mt-24"
                placeholder="نام:" onChange={setNewName} value={newName} />
              <Input className="bg-light blocked"
                placeholder="نام خانوادگی:" onChange={setNewFamily} value={newFamily} />
            </div>
          </div>
          <div className="ltr mt-32 px-8">
            <button className="bd-none bg-tomato iran-sans radius-4 font-10 text-top-nav"
              style={{ width: 85, padding: '5px 0' }}>
              ثبت</button>
            <button className="bd-none bg-none icon-button iran-sans radius-4 font-10 text-top-nav ml-16"
              onClick={() => toggleShow(false)}
              style={{ color: '#ffb1ccbb', padding: '5px 0', width: 85, border: '1px solid #ffb1ccbb' }}
              type="button">بازگشت</button>
          </div>
        </form>
      </div>
    </div> : <div></div>
  )
}
